import React, { Component } from 'react';
import StepButtons from '../../StepButtons';
import styled from 'styled-components';
import PrimaryText from '../PrimaryText';
import { NIGHTLIFE } from 'constants/index';
import RadioInput from 'components/RadioInput';

const SelectNightlifeBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const SelectNightlifePrimaryBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 70%;
  min-height: 500px;
  @media (max-width: 1000px) {
    width: 100%;
  }
`;

const Content = styled.div`
  display: flex;
  width: 95%;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
`;

class SelectNightlifeView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { step, state, changeStep, handleChange, nightlifeMaping } = this.props;

    return (
      <SelectNightlifeBox>
        <SelectNightlifePrimaryBox>
          <PrimaryText text="What types of nightlife interest you? Please select all that apply and rate your interest level low, medium, or high." />
          <Content>
            {NIGHTLIFE.map(nightlife => (
              <RadioInput
                style={{ marginBottom: 50 }}
                label={nightlife}
                name={nightlifeMaping[nightlife]}
                options={[
                  { numericValue: 0, text: 'Nothing' },
                  { numericValue: 1, text: 'Low' },
                  { numericValue: 2, text: 'Medium' },
                  { numericValue: 3, text: 'High' },
                ]}
                handleChange={handleChange}
                currentValue={state[nightlifeMaping[nightlife]]}
                verticalAlign
              />
            ))}
          </Content>
          <StepButtons
            backStep={() => changeStep(step - 1)}
            nextStep={() => changeStep(step + 1)}
          />
        </SelectNightlifePrimaryBox>
      </SelectNightlifeBox>
    );
  }
}

export default SelectNightlifeView;
